import { createFeature, createReducer, on } from '@ngrx/store'
import { casesActions } from './cases.actions'
import { CasesState } from './cases.state'
import { moveNodeToParent, removeNodeById } from './dataset-browser.utils'

const createInitialState = (): CasesState => ({
    cases: [],
    expandedFolderIds: [],
})

export const casesFeature = createFeature({
    name: 'cases',
    reducer: createReducer<CasesState>(
        createInitialState(),
        on(
            casesActions.casesLoaded,
            (_, { cases }): CasesState => ({ cases, expandedFolderIds: [] })
        ),
        on(casesActions.deleteFolder, (state, { folderId }): CasesState => {
            return {
                ...state,
                cases: removeNodeById(folderId, state.cases),
            }
        }),
        on(casesActions.moveFolder, (state, { folderId, parentId }): CasesState => {
            return {
                ...state,
                cases: moveNodeToParent(folderId, parentId, state.cases),
                expandedFolderIds: parentId
                    ? [...state.expandedFolderIds.filter(id => id !== parentId), parentId]
                    : state.expandedFolderIds,
            }
        }),
        on(casesActions.deleteDataset, (state, { datasetId }): CasesState => {
            return {
                ...state,
                cases: removeNodeById(datasetId, state.cases),
            }
        }),
        on(casesActions.moveDataset, (state, { datasetId, parentId }): CasesState => {
            return {
                ...state,
                cases: moveNodeToParent(datasetId, parentId, state.cases),
                expandedFolderIds: parentId
                    ? [...state.expandedFolderIds.filter(id => id !== parentId), parentId]
                    : state.expandedFolderIds,
            }
        }),
        on(casesActions.setExpandedFolders, (state, { folderIds }): CasesState => {
            return { ...state, expandedFolderIds: folderIds }
        }),
        on(casesActions.creatingFolderSucceeded, (state, { parentId }): CasesState => {
            return parentId
                ? {
                      ...state,
                      expandedFolderIds: [
                          ...state.expandedFolderIds.filter(folderId => folderId !== parentId),
                          parentId,
                      ],
                  }
                : state
        })
    ),
})

export const { reducer } = casesFeature
